import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import ApiLoader from "../Loaders/ApiLoader";

const ContentBuyerGraph = ({ data, loading }) => {
  const seriesData = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }

    const rejectedValues = Array(12).fill(0);
    const approvedValues = Array(12).fill(0);

    data.forEach((item) => {
      const monthIndex = parseInt(item.date.split("-")[1]) - 1;
      rejectedValues[monthIndex] = item.rejected;
      approvedValues[monthIndex] = item.approved;
    });

    return [
      {
        name: "Rejected",
        data: rejectedValues,
      },
      {
        name: "Approved",
        data: approvedValues,
      },
    ];
  }, [data]);

  const options = {
    chart: {
      height: 251,
      toolbar: {
        show: false,
      },
    },

    fill: {
      opacity: 1,
    },

    colors: ["#000", "#DCDCDC"],

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "70%",
        endingShape: "rounded",
        borderRadius: 8,
        dataLabels: {
          position: "top",
          total: {
            enabled: true,
            offsetY: -50,
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return val ? val : "";
      },
      style: {
        fontSize: "10px",
        fontFamily: "Inter",
        colors: ["#DCDCDC", "#000"],
      },
    },
    legend: {
      show: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      style: {
        colors: ["#7C7C7C"],
        fontSize: "10px",
        fontFamily: "Inter",
        fontWeight: 700,
      },
    },
    yaxis: {
      min: 0,
      tickAmount: 3,
    },
    grid: {
      show: true,
      strokeDashArray: 7,
      borderColor: "#E4E4E4",
    },
  };

  return (
    <>
      <ApiLoader loading={loading} />
      <ReactApexChart
        options={options}
        series={seriesData}
        type="bar"
        width={"100%"}
        height={250}
      />
    </>
  );
};

export default ContentBuyerGraph;
